import { Redirect } from 'react-router-dom';

import { isAuthorised } from 'utils/func';

import useAuth from 'providers/Auth/useAuth';

import LoginForm from 'components/pages/Login/LoginForm';

import './Login.style.scss';
import logo from 'assets/images/cps_logo.png';

const Login = () => {
  const { user } = useAuth();

  return user ? (
    // If user is "truthy" check the role of the user
    isAuthorised(['Admin', 'CPSAdmin', 'CPSUser', 'ASO', 'Authority'], user.roleName) ? (
      <Redirect to="/dashboard" />
    ) : // if the user's role is DBA redirect to courses
    isAuthorised(['DBA'], user.roleName) ? (
      <Redirect to="/courses" />
    ) : (
      // if the user is neither of the above roles redirect to flights
      <Redirect to="/flights" />
    )
  ) : (
    // If the user is "falsy" display the LoginForm
    <div className="Login">
      <div className="form">
        <div className="logoContainer">
          <img className="logo m-auto d-block" src={logo} alt="logo cps" />
        </div>
        <div className="container">
          <h1>Sign in</h1>
          <LoginForm />
          <p>Version : {process.env.REACT_APP_VERSION}</p>
        </div>
      </div>
      <div className="img" />
    </div>
  );
};

export default Login;
